import React from 'react'

const WrapperWithMargin = ({ marginValue, children }) => (
  <div style={{ margin: marginValue }}>{children}</div>
)

export default WrapperWithMargin;
